export const SHIPPING_TIME_PLACEHOLDER = '{shippingTime}';
export const FALLBACK_SHIPPING_TIME = '5-7';

export type CountryShippingTimes = {
  defaultShippingTime: string;
  byCountry: Record<string, string>;
};

export const FALLBACK_COUNTRY_SHIPPING_TIMES: CountryShippingTimes = {
  defaultShippingTime: FALLBACK_SHIPPING_TIME,
  byCountry: {},
};

type UniformTextField = {
  value?: string;
};

type CountryShippingTimeBlock = {
  fields?: {
    countryCode?: UniformTextField;
    shippingTime?: UniformTextField;
  };
};

export type CountryShippingTimesEntryEnvelope = {
  entry?: {
    type?: string;
    fields?: {
      defaultShippingTime?: UniformTextField;
      times?: { value?: CountryShippingTimeBlock[] };
    };
  };
};

function nonEmpty(value: string | undefined): string | undefined {
  const trimmed = value?.trim();
  return trimmed ? trimmed : undefined;
}

export function parseCountryShippingTimesEntry(
  envelope: CountryShippingTimesEntryEnvelope | undefined,
): CountryShippingTimes {
  const entry = envelope?.entry;
  if (!entry || (entry.type && entry.type !== 'countryShippingTimes')) {
    return FALLBACK_COUNTRY_SHIPPING_TIMES;
  }

  const byCountry: Record<string, string> = {};
  for (const block of entry.fields?.times?.value ?? []) {
    const countryCode = nonEmpty(block.fields?.countryCode?.value)?.toUpperCase();
    const shippingTime = nonEmpty(block.fields?.shippingTime?.value);
    if (!countryCode || !/^[A-Z]{2}$/.test(countryCode) || !shippingTime) {
      continue;
    }
    byCountry[countryCode] = shippingTime;
  }

  return {
    defaultShippingTime:
      nonEmpty(entry.fields?.defaultShippingTime?.value) ??
      FALLBACK_SHIPPING_TIME,
    byCountry,
  };
}

export function applyShippingTime(
  template: string | undefined,
  country: string | undefined,
  times: CountryShippingTimes,
): string | undefined {
  if (template === undefined) return undefined;

  const countryCode = country?.trim().toUpperCase();
  const shippingTime =
    (countryCode && times.byCountry[countryCode]) ||
    times.defaultShippingTime ||
    FALLBACK_SHIPPING_TIME;

  return template.replaceAll(SHIPPING_TIME_PLACEHOLDER, shippingTime);
}
